import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import RecordTypeNav from './RecordTypeNav';
import HomeCommands from './HomeCommands';
import RecordList from '../recordList/RecordList';
import RecordDetail from '../recordDetail/RecordDetail';
import Errors from '../errors/Errors';
import LegalMessage from '../legal/LegalMessage';
import CurrentUser from '../user/CurrentUser';
import icons from '../assets/icons';
import { getPlatformName, getPlatformDisplayName } from '../utility/platform';

import './Home.css';
import '../platform.css';
import packageJson from '../../package.json';

class HomeComponent extends Component {
  static get propTypes() {
    return {
      match: PropTypes.shape({
        params: PropTypes.shape({
          type: PropTypes.string,
          id: PropTypes.string
        }).isRequired
      }).isRequired,
      location: PropTypes.shape({
        search: PropTypes.string
      }).isRequired
    };
  }

  render() {
    const { type, id } = this.props.match.params;
    const searchParams = this.props.location.search;
    const idNumber = id ? parseInt(id, 10) : undefined;

    const platform = getPlatformName();
    const displayPlatform = getPlatformDisplayName();
    return (
      <div className={classnames('Home', platform)}>
        <div className="Home-header App-header">
          <h1>ORB{displayPlatform}</h1>
          <div className="Home-help">
            <CurrentUser />
            <ul>
              <li><label>Email:</label><a href="mailto:fm.uk.london.PPQSupport@rabobank.com">PPQ Support</a></li>
              <li><label>Phone:</label>x3885</li>
              <li><label>ORB:</label>v{packageJson.version}</li>
            </ul>
            <div className="Home-icon">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="http://sharepoint.rabonet.com/sites/globalfinancialmarkets/Shared%20Documents/Procedures/ORB%20Blotter%20User%20Guide.docx?Web=1"
              >
                <img alt="Help" src={icons.white.help} />
              </a>
            </div>
          </div>
          <RecordTypeNav />
        </div>
        <HomeCommands />
        <div className="Home-main">
          <div className="Home-list">
            <RecordList type={type} selectedId={idNumber} searchParams={searchParams} />
          </div>
          <div className="Home-detail">
            <RecordDetail type={type} id={idNumber} />
          </div>
        </div>
        <Errors />
        <LegalMessage />
      </div>
    );
  }
}

export default HomeComponent;



// WEBPACK FOOTER //
// ./src/home/Home.js